<template>
  <div>
    <el-dialog :visible="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :append-to-body="true"
      :modal="true"
      :modal-append-to-body="true"
      custom-class="custom-confirm-dialog"
      :width="dialogWidth"
      center>
      <div class="dialog-content">
        <div class="icon-wrapper">
          <div class="icon-circle">
            <i :class="iconClass"></i>
          </div>
        </div>
        <div class="title">{{ title }}</div>
        <div class="msg">
          <div class="cn-text" v-if="msg">{{ msg }}</div>
          <div class="en-text" v-if="enMsg">{{ enMsg }}</div>
        </div>
        <div class="dialog-footer">
          <div class="refresh btn" v-if="showRefresh" :class="{ disabled: refreshLoading }" @click="refreshFn">
            <span class="cn-text">{{ refreshLoading ? refreshLoadingText : refreshText }}</span>
          </div>
          <div class="cancel btn" v-if="cancel" @click="cancelFn">
            <span class="cn-text">{{ cancel }}</span>
            <span class="en-text" v-if="enCancel">{{ enCancel }}</span>
          </div>
          <div class="confirm btn" v-if="confirm" @click="confirmFn">
            <span class="cn-text">{{ confirm }}</span>
            <span class="en-text" v-if="enConfirm">{{ enConfirm }}</span>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: '提示'
    },
    enTitle: {
      type: String,
      default: ''
    },
    msg: {
      type: String
    },
    enMsg: {
      type: String
    },
    confirm: {
      type: String
    },
    enConfirm: {
      type: String
    },
    cancel: {
      type: String
    },
    enCancel: {
      type: String
    },
    showIcon: {
      type: Boolean,
      default: false
    },
    showRefresh: {
      type: Boolean,
      default: false
    },
    refreshText: {
      type: String,
      default: '刷新'
    },
    refreshLoadingText: {
      type: String,
      default: '刷新中...'
    },
    iconClass: {
      type: String,
      default: 'el-icon-warning'
    }
  },
  data () {
    return {
      refreshLoading: false,
      refreshThrottleTimer: null,
      windowWidth: typeof window !== 'undefined' ? window.innerWidth : 1024
    }
  },
  computed: {
    dialogWidth () {
      return '70%'
    }
  },
  mounted () {
    window.addEventListener('resize', this.handleWindowResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleWindowResize)
    if (this.refreshThrottleTimer) {
      clearTimeout(this.refreshThrottleTimer)
      this.refreshThrottleTimer = null
    }
  },
  methods: {
    handleWindowResize () {
      this.windowWidth = window.innerWidth
    },
    cancelFn () {
      this.$emit('cancel')
    },
    confirmFn () {
      this.$emit('confirm')
    },
    refreshFn () {
      if (this.refreshLoading) return
      this.refreshLoading = true
      this.$emit('refresh')
      // 防止高频重复点击：至少 1.2s 后可再次触发
      this.refreshThrottleTimer = setTimeout(() => {
        this.refreshLoading = false
      }, 1200)
    }
  }
}
</script>
<style lang="less" scoped>
// 确保弹窗在最顶层显示
::v-deep .custom-confirm-dialog {
  border-radius: 28px;
  overflow: visible !important;
  z-index: 3000 !important;
  position: relative !important;
  min-height: auto !important;
  height: auto !important;
  display: block !important;

  .el-dialog {
    min-height: auto !important;
    height: auto !important;
    display: block !important;
    border-radius: 28px !important;
    overflow: hidden !important;
  }

  .el-dialog__header {
    padding: 0;
    margin: 0;
    display: none !important;
  }

  .el-dialog__body {
    padding: 0 !important;
    min-height: auto !important;
    height: auto !important;
    display: block !important;
    overflow: visible !important;
  }
}

// 弹窗包装器 - 确保在最顶层
::v-deep .el-dialog__wrapper {
  z-index: 3000 !important;
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  overflow: visible !important;
  width: 100% !important;
  height: 100% !important;

  .el-dialog {
    position: relative !important;
    margin: 0 auto !important;
    min-height: auto !important;
    height: auto !important;
    display: block !important;
    overflow: visible !important;
    width: calc(100vw - 24px) !important;
    max-width: 500px !important;
  }
}

// 遮罩层
::v-deep .v-modal {
  z-index: 2999 !important;
  background-color: rgba(0, 0, 0, 0.5) !important;
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
}

.dialog-content {
  padding: 35px 30px 25px !important;
  background: #fff !important;
  text-align: center !important;
  min-height: auto !important;
  height: auto !important;
  display: block !important;
  overflow: visible !important;
  width: 100% !important;
  box-sizing: border-box !important;
  position: relative !important;
  overflow: hidden !important;
  border-radius: 28px !important;
}

.icon-wrapper {
  margin-bottom: 20px;

  .icon-circle {
    width: 70px;
    height: 70px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #f8bd1d 0%, #ffd54f 100%);
    border-radius: 50%;
    box-shadow: 0 4px 15px rgba(248, 189, 29, 0.3);

    i {
      font-size: 36px;
      color: #fff;
    }
  }
}

.title {
  font-size: 22px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 20px;
  letter-spacing: 0.5px;
}

.msg {
  color: #606266;
  margin-bottom: 30px;
  font-size: 15px;
  line-height: 1.8;
  padding: 0 5px;
  word-break: break-word;
}
.msg .en-text{
  margin-top: 6px;
  font-size: 0.86em;
  line-height: 1.55;
  color: #7b8794;
}

.dialog-footer {
  display: flex;
  justify-content: center;
  gap: 12px;
  width: 100%;
}

.btn {
  flex: 1;
  min-width: 110px;
  height: 42px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 14px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  line-height: 1.1;
}
.btn .en-text{
  margin-top: 2px;
  font-size: 0.72em;
  font-weight: 600;
  line-height: 1.05;
}

.confirm {
  background: linear-gradient(135deg, #b81c25 0%, #d32f2f 100%);
  color: #fff;
  border: none;
  box-shadow: 0 4px 15px rgba(184, 28, 37, 0.3);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(184, 28, 37, 0.4);
  }

  &:active {
    transform: translateY(0);
  }
}

.refresh {
  flex: 0 0 50%;
  max-width: 50%;
  background: linear-gradient(135deg, #2f5bea 0%, #4c7ef4 100%);
  color: #fff;
  border: none;
  box-shadow: 0 4px 15px rgba(47, 91, 234, 0.28);
  margin: 0 auto;
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(47, 91, 234, 0.36);
  }
  &:active {
    transform: translateY(0);
  }
  &.disabled {
    opacity: 0.7;
    cursor: not-allowed;
    pointer-events: none;
    box-shadow: none;
  }
}

.cancel {
  background: #fff;
  color: #666;
  border: 2px solid #e0e0e0;
  transition: all 0.3s;

  &:hover {
    border-color: #b81c25;
    color: #b81c25;
    background: #fff5f5;
  }
}

// 响应式优化
@media (max-width: 1024px) {
  .title {
    font-size: 37px;
  }

  .msg {
    font-size: 30px;
  }

  .btn {
    font-size: 30px;
    height: 56px;
    line-height: 56px;
  }

  .icon-wrapper .icon-circle i {
    font-size: 46px;
  }

  .refresh {
    flex: 0 0 40%;
    max-width: 40%;
    margin: 0 auto;
  }
}

@media (max-width: 768px) {
  ::v-deep .el-dialog__wrapper .el-dialog {
    width: calc(100vw - 16px) !important;
    max-width: calc(100vw - 16px) !important;
  }

  .dialog-content {
    padding: 22px 14px 16px;
  }

  .title {
    font-size: 35px;
    margin-bottom: 16px;
  }

  .msg {
    font-size: 29px;
    margin-bottom: 24px;
    line-height: 1.6;
  }

  .btn {
    height: 66px;
    line-height: 66px;
    font-size: 29px;
    min-width: 0;
    width: 100%;
  }

  .dialog-footer {
    flex-direction: column;
    gap: 8px;
  }

  .refresh {
    flex: 0 0 60%;
    max-width: 60%;
    margin: 0 auto;
    // width: auto;
    align-self: center;
  }

  .icon-wrapper .icon-circle {
    width: 60px;
    height: 60px;

    i {
      font-size: 40px;
    }
  }
}
</style>
